import axios from "axios";
import { getApiBaseUrl } from "./apiBase";

const API = getApiBaseUrl();

export function cartLineKey(item) {
  const order = String(item?.customer_order_number || "").trim();
  return `${item?.product_id || ""}::${order}`;
}

export function cartItemQueryParams(item) {
  const order = String(item?.customer_order_number || "").trim();
  return order ? { customer_order_number: order } : {};
}

export async function batchAddToSupplierCart(token, items) {
  const { data } = await axios.post(
    `${API}/cart/items/batch`,
    { items },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return data;
}
